module.exports = __webpack_public_path__ + "img/category-2.d4eb44cd.svg";